import clsx from "clsx";
import type { ButtonProps } from "./button.types";
import { getButtonClasses } from "./button.definitions";

export default function Button({
  variant = "primary",
  size = "md",
  disabled = false,
  loading = false,
  leftIcon,
  rightIcon,
  children,
  className,
  onClick,
  ...props
}: ButtonProps) {
  const isDisabled = disabled || loading;

  return (
    <button
      className={clsx(
        getButtonClasses(variant, size, isDisabled, loading),
        className
      )}
      disabled={isDisabled}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <>
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-current mr-3" />
          <span>Carregando...</span>
        </>
      ) : (
        <>
          {leftIcon && <span className="mr-3">{leftIcon}</span>}
          {children}
          {rightIcon && <span className="ml-3">{rightIcon}</span>}
        </>
      )}
    </button>
  );
}
